define([
    "jquery",
    "underscore",
    "marionette",
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '#payment-root',

        behaviors: {

        },

        ui: {
            'qrCode':'#qr_code',
            'btnCancel': '#btn_cancel'
        },

        events: {
            'click @ui.btnCancel': 'cancelTransaction'
        },

        initialize: function(){
            this.bindUIElements();
        },
    });
});
